/* @ngInject */

export default () => {
  return {
    restrict: 'E',
    link: function (scope, element) {
      element.bind('error', function () {
        element.prop(
          'src',
          'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
        );
      });
    }
  };
};
